<template>
  
    <div >
      <onedevicepolicy ></onedevicepolicy>
      <!-- <twodevicepolicy v-else-if="!$store.state.currentOrg.org.isPrimaryOrganisation&&!$store.state.currentOrg.org.primaryOrganisation.oneDevicePolicy"></twodevicepolicy> -->
    </div>

</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import oneDevicePolicyServiceAccounts from '@/components/OneDeviceISPServiceAccounts.vue';
import twoDevicePolicyServiceAccounts from '@/components/TwoDeviceISPServiceAccounts.vue';

export default {
  components: {
    onedevicepolicy: oneDevicePolicyServiceAccounts,
    twodevicepolicy: twoDevicePolicyServiceAccounts
  }
};
</script>